const eventsForAutocompletersInitialization = ["turbo:load", "turbo:render", "autocompleters-initialisieren"];
eventsForAutocompletersInitialization.forEach(eventName => {
  document.addEventListener(eventName, function() {
    initAutocompleters();
  });
});

function initAutocompleters() {
  $('.pferd_autocompleter').autocomplete({
    source: function(request, response){
      var src = '/pferde/autocomplete?term=' + request.term;
      if (this.element.hasClass('nur_aktive')) {
        src += '&nur_aktive=true';
      }
      if (this.element.hasClass('nur_lebende')) {
        src += '&nur_lebende=true';
      }
      if (this.element.hasClass('braucht_fei_eintrag')) {
        src += '&braucht_fei_eintrag=true';
      }
      if (this.element.hasClass('pferde_nur_internationale_nennungen')) {
        src += '&pferde_nur_internationale_nennungen=true';
      }
      $.get(src).then(response).catch(function(){ response(null); });
    },
    minLength: 2,
    select: function(event, ui) {
      var hiddenFieldId = $(this).data('hidden-field-id');
      if (hiddenFieldId) {
        $(hiddenFieldId).val(ui.item.id);
      }
    }
  });

  $('.reiter_autocompleter').autocomplete({
    source: function(request, response){
      var src = '/reiter/autocomplete?term=' + request.term;
      if (this.element.hasClass('braucht_fei_eintrag')) {
        src += '&braucht_fei_eintrag=true';
      }
      $.get(src).then(response).catch(function(){ response(null); });
    },
    minLength: 2,
    select: function(event, ui) {
      var hiddenFieldId = $(this).data('hidden-field-id');
      if (hiddenFieldId) {
        $(hiddenFieldId).val(ui.item.id);
      }
    }
  });

  $('.domain-autocompleter-plz').autocomplete({
    source: "/plz",
    minLength: 1,
    delay: 0,
    autoFocus: true,
    select: function(event, ui) {
      var data = $(this).data();
      $.each(['plz', 'ort', 'kanton', 'land'], function(index, value) {
        var field_id = data[value + 'FieldId'];
        if(field_id) {
          var $oldval = $(field_id).val();
          var $newval = ui.item[value];
          if($newval !== $oldval) {
            $(field_id).val($newval);
            $(field_id).trigger('autofill');
          }
        }
      });
    }
  });

  var old_searchterm = '';
  $('.verein_suche').on('keyup', function () {
    var searchterm = $(this).val();
    if (searchterm.length > 2) {
      if (searchterm != old_searchterm) {
        old_searchterm = searchterm;
        $.get('/vereine/suche', {
          term: searchterm
        }).done(function (data) {
          $('.verein_resultate').html(data);
        }).fail(function (error) {
          $('.verein_resultate').html(error);
        });
      }
    } else {
      $('.verein_resultate').html('');
    }
  });
  $('#vereindaten').on('click', '.verein-result-table tr.verein', function () {
    var row = $(this);
    $('.verein-result-table tr.selected').removeClass('selected');
    row.addClass('selected');
    $('#formular_objekt_verein_id').val(row.data('verein-id'));
    $('#edit_formular_objekt').submit();
  });
  $('#vereindaten').on('click', '.verein-result-table tr.verein a', function (event) {
    event.stopPropagation();
  });
  window.resetVereinID = function() {
    $('#verein_id').val('');
    $('.vereins-control-group').show();
    $('.verein_resultate').html('');
    $('.verein_suche').val('');
  };

  $('#selbstregistrierungs-verein').on('click', '.verein-result-table tr.verein', function () {
    // Code fast identisch auch in selfservice/app/views/selbstregistrierung/new.html.haml
    var row = $(this);
    $('tr.verein').hide();
    $('.vereins-control-group').hide();
    row.addClass('selected');
    row.show();
    if(!row.hasClass('has-trash')) {
      row.find('td:last').prepend('<span class="float-end"><a href="javascript:resetVereinID()"><span class="fa-solid fa-trash text-danger"></span></a></span>');
      row.addClass('has-trash')
    }
    $('#verein_id').val(row.data('verein-id'));
  });
  $('#selbstregistrierungs-verein').on('click', '.verein-result-table tr.verein a', function (event) {
    event.stopPropagation();
  });
}
